<h2 class="secondary word-break">
    {{ 'tokens.browser.pincode.choosePin' | apContent }}
</h2>
<p>{{ 'tokens.browser.pincode.info' | apContent }}</p>

<form [formGroup]="form" (ngSubmit)="submit()">
    <div class="ap-margin-bottom-4 ap-display-block pincode-flex">
        <div id="pincode-help-text" data-bb="help-text">
            <p class="ap-help-text ap-margin-bottom-2 ap-margin-top-2">
                <ap-content key="tokens.browser.pincode.helpText.intro"></ap-content>
            </p>
            <ul>
                <li>
                    <p class="ap-help-text" aria-hidden="true"><ap-content key="tokens.browser.pincode.helpText.ascending"></ap-content></p>
                    <span class="sr-only"><ap-content key="tokens.browser.pincode.helpText.ascendingSpoken"></ap-content></span>
                </li>
                <li>
                    <p class="ap-help-text" aria-hidden="true">
                        <ap-content key="tokens.browser.pincode.helpText.descending"></ap-content>
                    </p>
                    <span class="sr-only"><ap-content key="tokens.browser.pincode.helpText.descendingSpoken"></ap-content></span>
                </li>
                <li>
                    <p class="ap-help-text" aria-hidden="true"><ap-content key="tokens.browser.pincode.helpText.repeated"></ap-content></p>
                    <span class="sr-only"><ap-content key="tokens.browser.pincode.helpText.repeatedSpoken"></ap-content></span>
                </li>
            </ul>
        </div>
        <ap-pincode-input
            data-bb="pincode-input"
            [label]="'tokens.browser.pincode.label' | apContent"
            [formControl]="form.get('pincode') | apFormControl"
            [attr.aria-label]="'tokens.browser.pincode.info' | apContent"
            [messages]="errorMessage"
        >
        </ap-pincode-input>
    </div>

    <div class="ap-margin-bottom-4 ap-display-block">
        <div class="ap-flex ap-flex-row ap-flex-sm-column-reverse ap-flex-1">
            <ap-button (onClick)="goBack()" data-bb="back" variant="secondary" [isDisabled]="buttonsDisabled">
                {{ 'tokens.browser.pincode.back' | apContent }}
            </ap-button>
            <ap-button type="submit" data-bb="submit" [isDisabled]="buttonsDisabled">
                {{ 'tokens.browser.pincode.submit' | apContent }}
            </ap-button>
        </div>
    </div>
</form>
